import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "skeleton h-44 mt-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" Geomagnetic storm index. Value above 6 can interfere with the onboard GPS on the drone . Read more "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "blank",
    class: "text-blue-400 hover:underline",
    href: "https://altigator.com/en/gps-status/"
  }, "here")
], -1)

import { onMounted, ref } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  ScatterDataPoint,
  Tooltip,
  Title,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { TChartData, TChartOptions } from 'vue-chartjs/dist/types';
import { getKPIndexs } from '@/services/kpi.services';
import isSameDay from 'date-fns/isSameDay';
import format from 'date-fns/format';


export default /*#__PURE__*/_defineComponent({
  __name: 'KPIndexWidget',
  setup(__props) {

ChartJS.register(Tooltip, Title, LineElement, PointElement);

const loading = ref(true);
const currTimeIndex = ref();

const chartData = ref<TChartData<'line', ScatterDataPoint[], number>>({
  labels: [],
  datasets: [],
});
const chartOptions = ref<TChartOptions<'line'>>({
  responsive: true,
  plugins: {
    title: {
      text: 'Kp Index (24 Hrs)',
      display: true,
    },
    legend: { display: false },
  },
  scales: {
    x: {
      type: 'time',
      time: { tooltipFormat: 'PP p' },
      grid: { drawOnChartArea: false },
      ticks: {
        major: { enabled: true },
        source: 'labels',
        font: (ctx) => {
          const fontStyle = { size: 10 };
          if (ctx.index === currTimeIndex.value) {
            fontStyle['weight'] = 'bold';
          }
          return fontStyle;
        },
        callback: (v, i, ticks) => {
          if (ticks[i - 1] && !isSameDay(ticks[i - 1].value, ticks[i].value as number)) {
            return format(ticks[i].value, 'd/MM p');
          }

          return format(ticks[i].value, 'p') + (currTimeIndex.value === i ? '*' : '');
        },
      },
    },
    y: {
      title: { display: true, text: 'KP Index' },
      grid: { drawOnChartArea: false },
      max: 9,
      min: 0,
      ticks: { autoSkip: true, count: 5, font: { size: 10 } },
    },
  },
});

const getData = async () => {
  loading.value = true;
  const result = await getKPIndexs();

  if (result.data.success) {
    chartData.value.labels = result.data.kpis.map((kpi) => Date.parse(kpi.timestamp));

    // time difference adjacent time series points (i+1)th - ith
    const timeDiff = chartData.value.labels[1] - chartData.value.labels[0];
    // getting the label from which current time to replace
    for (let v = 0; v < result.data.kpis.length; v++) {
      const el = result.data.kpis[v];
      if (Math.abs(Date.now() - Date.parse(el.timestamp)) / timeDiff <= 0.5) {
        chartData.value.labels.splice(v, 1, Date.now());
        currTimeIndex.value = v;
        break;
      }
    }

    chartData.value.datasets = [
      {
        data: result.data.kpis.map((kpi) => ({
          x: Date.parse(kpi.timestamp),
          y: kpi.kpi,
        })),
        label: 'KPI',
        backgroundColor: '#f60',
        borderColor: 'rgba(255, 102, 0, 0.3)',
        pointRadius: 2,
        borderWidth: 2,
        pointHoverBackgroundColor: 'rgba(255, 102, 0, 0.3)',
        pointBorderWidth: 0,
        pointHoverBorderWidth: 0,
        cubicInterpolationMode: 'monotone',
      },
    ];
  }
  loading.value = false;
};

onMounted(() => {
  getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createBlock(_unref(Line), {
          key: 1,
          height: 250,
          "chart-options": chartOptions.value,
          "chart-data": chartData.value
        }, null, 8, ["chart-options", "chart-data"])),
    _hoisted_2
  ]))
}
}

})